<div *ngIf="visible" class="cookie-banner">
  <!-- <div class="img-container">    <img src="assets/newImages/cross.svg" alt="" (click)="rejectAll()">
      </div> -->
  <div class="text-container">
    

    <p>
      This website may automatically collect information from you,through cookies to automatically collect information,
      measure and analyse how you use the Platform, includeing which pages you view most often and how you interact with
      content, enhance your experience using the Platform , improve the platform, provide you with advertising, and
      measure the effectiveness of advertisements and other content. By clicking "Accept all", you agree to our use of
      cookies.To learn more, you may read our <a href="/privacy-policy"> Privacy Policy </a> and <a href="/cookiePolicy"> Cookie Policy</a> .
      
    </p>
  </div>
  <div class="actions">
    <button class="accept" (click)="acceptAll()">Accept</button>

    <button class="reject" (click)="rejectAll()">Reject</button>
  </div>
</div>